import { render, staticRenderFns } from "./SpecSummary.vue?vue&type=template&id=663e5886&scoped=true&lang=pug&"
import script from "./SpecSummary.vue?vue&type=script&lang=js&"
export * from "./SpecSummary.vue?vue&type=script&lang=js&"
import style0 from "./SpecSummary.vue?vue&type=style&index=0&id=663e5886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e5886",
  null
  
)

export default component.exports